import logo from './logo.svg';
import './App.css';
import ScrollVelocity from './screens/BettyScreen';
import FloatingWhatsAppButton from './components/FloatingButton/FloatingButton';
import ThirdScreen from './screens/ThirdScreen';
import HeroSection from './screens/FirstScreen';
import BeautyGrid from './screens/SecondScreen';
import AboutMe from './components/me/Me';
import ForthScreen from './screens/ForthScreen';
import HomePage from './screens/VideoScreen';
import ByMe from './components/ByMe/ByMe';
import SiteMap from './components/map/Map';
import PrivacyPolicy from './components/privacy/Privacy';

function App() {
  return <>
  {/* "Betty Knafo", */}
    {/* <ScrollVelocity texts={["BK  "]}  numCopies={40}/> */}
    {/* <HeroSection/> */}
       {/* <ScrollVelocity texts={["השירותים שלנו"]}  numCopies={40}/> */}
  
  <HomePage/>
<ThirdScreen/>
       <AboutMe/>  
       <ForthScreen/>       
       <SiteMap/>   
      <PrivacyPolicy/>
       <ByMe/> 
  </>
}

export default App;
